import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Base styles first, deliberately: CSS imports land in module evaluation
// order, so component stylesheets imported later can override at equal
// specificity.
import "./styles/fonts.css";
import "./styles/theme.css";

import App from "./App";
import { BusinessProvider } from "./data/BusinessContext";
import { LanguageProvider } from "./i18n/LanguageContext";
import { ThemeProvider } from "./theme/ThemeContext";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <LanguageProvider>
          <BusinessProvider>
            <App />
          </BusinessProvider>
        </LanguageProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
